<template>
  <div>{{ groupList }}</div>
</template>

<script>
export default {
  name: "sidebarTree",
  data() {
    return {};
  },
  props: {
    groupList: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/sidebarTree/sidebar_tree.vue